import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';

const endpoint = 'ums/v1/crm/brands/poc/calls';
export const editPocContactDetailsEndpointIdentifier = endpoint;

interface BodyType {
  contactDetails: string;
}

type TData = Record<string, any>;
type TError = AxiosError;

type TVariables = {
  pocCallId: number;
  body: BodyType;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useEditPocContactDetailsApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async ({ pocCallId, body }: TVariables) => {
    const fullEndpoint = `${endpoint}/${pocCallId}/contact-details`;

    try {
      const { data } = await http.patch(fullEndpoint, body);

      toast({
        description: 'Contact details have been updated successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
